import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Actions = styled(Grid)({
  // display: "flex",
  flexFlow: "row",
  alignContent: "start",
  padding: "1px 1px",
  minWidth: "400px",
  minHeight: "250px",
});
